<tour-step-template>
  <ng-template let-step="step">

    <div class="flex-align-left">
      <p class="tour-step-header"><b>{{step?.title}}</b></p>
    </div>

    <p class="tour-step-content">{{step?.content}}</p>
    <div class="tour-step-navigation">
      <div style="display: flex;">
        <button *ngIf="!tourService.hasNext(step)" type="button" class="btn btn-move"
                (click)="tourService.end()">{{'tour.tour-close-button' | translate}}</button>
        <button *ngIf="tourService.hasNext(step)" type="button" class="btn btn-move"
                (click)="tourService.end()">{{'tour.tour-skip-button' | translate}}</button>

        <div style="margin-left: auto;">
          <button *ngIf="tourService.hasPrev(step)" type="button" class="btn btn-move"
                  (click)="tourService.start()">{{'tour.tour-reset-button' | translate}}</button>
          <button *ngIf="tourService.hasPrev(step)" type="button" class="btn btn-move"
                  (click)="tourService.prev(); reviewPrevNext()"><i class="fa fa-chevron-left fa-fw"></i></button>
          <button *ngIf="tourService.hasNext(step)" type="button" class="btn btn-move"
                  (click)="tourService.next(); reviewPrevNext()"><i class="fa fa-chevron-right fa-fw"></i></button>


        </div>
      </div>

    </div>
  </ng-template>
</tour-step-template>

<div id="welcome_tour" class="modal fade qrcode" role="dialog" style=" padding-left: 0px;" data-backdrop="static"
     data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan qrcode_scan1 amount_div boxs">
          <div class="logohome boxs1">
            <img src="{{imgUrl + 'img/obsidiam_logo_elppua.png'}}" class="img-responsive dekstoplogo1">
          </div>
          <p style="padding: 40px; text-align: justify">
            {{'tour.tour-welcome1'|translate}}<br><br>{{'tour.tour-welcome2'|translate}}</p>
          <div class="boxs conf_btn">
            <ul>
              <li>
                <a href="javascript:" data-dismiss="modal" (click)="startGlobalTour(false)"
                   class="back_btn minWidthButton">{{'tour.tour-skip-button'|translate}}</a>
              </li>
              <li>
                <a href="javascript:" data-dismiss="modal" (click)="startGlobalTour(true)"
                   class="addaddress minWidthButton">{{'tour.start'|translate}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
